import axios from 'axios';
import { Message } from 'element-ui';

// 全局配置
axios.defaults.timeout = 500000;

// 封装请求方法（支持取消请求，但默认不主动取消）
export default {
  get(path = '', data = {}, config = {}) {
    return new Promise((resolve, reject) => {
      axios.get(path, {
        params: data,
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
          'token': localStorage.getItem('token')
        },
        ...config // 允许传入自定义配置（如 signal）
      })
      .then(response => {
        resolve(response.data);
      })
      .catch(error => {
        this._handleError(error, reject);
      });
    });
  },

  post(path = '', data = {}, config = {}) {
    return new Promise((resolve, reject) => {
      axios.post(path, data, {
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
          'token': localStorage.getItem('token')
        },
        ...config
      })
      .then(response => {
        resolve(response.data);
      })
      .catch(error => {
        this._handleError(error, reject);
      });
    });
  },

  // 统一的错误处理
  _handleError(error, reject) {
    // 1. 请求被取消（主动取消或页面跳转）
    if (axios.isCancel(error)) {
      console.warn('Request canceled:', error.message);
      return;
    }

    // 2. 网络错误（无响应）
    if (!error.response) {
      Message.error('网络异常，请检查连接');
      reject(new Error('Network Error'));
      return;
    }

    // 3. 业务错误（如 401）
    const { status, data } = error.response;
    if (status === 401) {
      localStorage.removeItem('token');
      window.location.href = '/login'; // 跳转登录页
    } else {
      Message.error(data.message || `请求失败 (${status})`);
      reject(error);
    }
  }
};